import './style.scss'
import UserIndicator from '../../components/userIndicator/UserIndicator';
import QuickSearch from '../../components/quickSearch/QuickSearch';
import { useAppSelector } from '../../redux/hooks';
import MobileQuickSearch from '../../components/mobileQuickSearch/MobileQuickSearch';
import HeaderLogo from './logo/HeaderLogo';

function Header() {
	const useMobileLayout = useAppSelector(state => state.resize.useMobileLayout)
	const showQuickSearchMobile = useAppSelector(state => state.search.showQuickSearchMobile)

	return (
		<div className="header-wrap">
			<div className='header-top-wrap'>
				<HeaderLogo />
				{useMobileLayout && <MobileQuickSearch />}
				<UserIndicator />
			</div>
			{showQuickSearchMobile &&
				<div className='header-search-wrap'>
					<QuickSearch />
				</div>
			}
		</div>
	)
}

export default Header